<div fxLayout="row" class="mat-h3" fxLayoutAlign="center center"> Test your form</div>
<div fxLayout="row">
  <app-flow-form [flow]="dialogRef?.flowMap"></app-flow-form>
</div> 